import { Component, EventEmitter, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
  ],
})
export class WelcomeComponent {
  @Output() goToLoginEvent = new EventEmitter<void>();
  @Output() goToRegisterEvent = new EventEmitter<void>();
  @Output() closeModalEvent = new EventEmitter<void>();

  public activeModal = inject(NgbActiveModal);

  goToLogin() {
    this.goToLoginEvent.emit();
  }

  goToRegister() {
    this.goToRegisterEvent.emit();
  }

  closeModal() {
    this.closeModalEvent.emit();
  }
}
